import { render } from "./TranslationImporter.vue?vue&type=template&id=b95e0d50"
import script from "./TranslationImporter.vue?vue&type=script&lang=js"
export * from "./TranslationImporter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__